<template>
	<div class="bg-white px-3 goods_create"
		style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'rcgl_ddcl_rcdd' }" style="position: absolute;top: 32px;left: 200px;">
			<el-button size="mini">回到入仓订单</el-button>
		</router-link>
		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 33%;">
					<el-form-item label="客户名称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr"
							:disabled="lists.id != 0 ? true : false">
							<el-option v-for="item in khlist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="存储方式">
						<el-select v-model="lists.ccfs" filterable style="width: 90%;" size="mini">
							<el-option v-for="item in ccfslist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<div class="d-flex">
						<div style="width: 50%;">
							<el-form-item label="计费单位">
								<el-select v-model="lists.jfdw" style="width: 90%;" size="mini">
									<el-option v-for="item in jfdwlist" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<!-- <div style="width: 50%;" v-if="lists.jfdw == 2">
							<el-form-item label="计费模式">
								<el-select v-model="lists.jfms" style="width: 90%;" size="mini">
								    <el-option v-for="item in jfmslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div> -->
						<!-- 修改1 -->
						<!-- <div style="width: 50%;">
							<el-form-item label="计费模式">
								<el-select v-model="lists.jfms" style="width: 90%;" size="mini">
									<el-option v-for="item in jfmslist" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div> -->
					</div>
				</div>
				<div style="width: 34%;">
					<el-form-item label="客户简称">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr"
							:disabled="lists.id != 0 ? true : false">
							<el-option v-for="item in khlist" :key="item.id" :label="item.j_name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="货物类型">
						<el-select v-model="lists.hwlx" filterable style="width: 90%;" size="mini">
							<el-option v-for="item in hwlxlist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="计费周期">
						<el-select v-model="lists.jfzq" filterable style="width: 90%;" size="mini">
							<el-option v-for="item in jfzqlist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="编号">
						<div style="color: #0091ff;">{{ lists.bh }}</div>
					</el-form-item>
					<el-form-item label="日期">
						<el-date-picker v-model="lists.ddrq" align="right" type="date" size="mini" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" style="width: 90%;" :picker-options="pickerOptions">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="仓库">
						<el-select v-model="lists.ck_id" filterable style="width: 90%;" size="mini">
							<el-option v-for="item in cklist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 33%;">
					<el-form-item label="订单属性">
						<el-select v-model="lists.ddsx" filterable style="width: 90%;" size="mini">
							<el-option v-for="item in ddsxlist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 66%;">
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 98%;" type="textarea" :rows="1"></el-input>
					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 100%;">
					<el-form-item label="其他费用">
						<div class="d-flex">
							<el-checkbox v-model="lists.flfy_status">分类费</el-checkbox>
							<el-checkbox v-model="lists.gcf_status">过车费</el-checkbox>
							<el-checkbox v-model="lists.yf_status">运费</el-checkbox>
							<el-checkbox v-model="lists.lmf_status">拉膜费</el-checkbox>
							<!-- 新增 -->
							<el-checkbox v-model="lists.jbf_status">加班费</el-checkbox>
							<el-checkbox v-model="lists.byf_status">搬运费</el-checkbox>
							<el-checkbox v-model="lists.tbf_status">贴标费</el-checkbox>
							<el-checkbox v-model="lists.cmf_status">抄码费</el-checkbox>
							<el-checkbox v-model="lists.cdf_status">场地费</el-checkbox>
							<el-checkbox v-model="lists.dbf_status">打包费</el-checkbox>
							<el-checkbox v-model="lists.fdf_status">复冻费</el-checkbox>
							<el-checkbox v-model="lists.gbf_status">过磅费</el-checkbox>
						</div>

					</el-form-item>
				</div>
			</div>
			<div class="d-flex">
				<div style="width: 25%;">
					<el-form-item label="分类费类型" v-if="lists.flfy_status == true">
						<el-select v-model="lists.flfylx" filterable style="width: 50%;" size="mini">
							<el-option v-for="item in flfylxlist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="运费" v-if="lists.yf_status == true">
						<el-select v-model="lists.thlx" placeholder="请选择" size="mini" style="width: 50%;"
							@change="yfjs">
							<el-option v-for="item in thlxlist" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="过车费" v-if="lists.gcf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zgcf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[6].price }} * {{ khjfpz[6].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[6].unit
								== 2 ? lists.hwzmj + '平方' : khjfpz[6].unit == 3 ? lists.hwzbs + '板' : lists.hwzjs + '件' }}
						</div>
					</el-form-item>
				</div>
				<div style="width: 25%;">

					<el-form-item label="是否专车" v-if="lists.thlx == 4">
						<el-radio-group v-model="lists.thlx_sl_zc" size="mini" @change="yfjs">
							<el-radio-button label="0">否</el-radio-button>
							<el-radio-button label="1">是</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="实际运费" v-else-if="lists.thlx == 5">
						<el-input-number v-model="lists.zyf" :precision="2" size="mini"></el-input-number>
					</el-form-item>

					<el-form-item label="拉膜费" v-if="lists.lmf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zlmf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[8].price }} * {{ khjfpz[8].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[8].unit
								== 2 ? lists.hwzmj + '平方' : khjfpz[8].unit == 3 ? lists.hwzbs + '板' : lists.hwzjs + '件' }}
						</div>
					</el-form-item>
					<el-form-item label="加班费" v-if="lists.jbf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zjbf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[7].price }} * {{ khjfpz[7].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[7].unit
								== 2 ? lists.hwzmj + '平方' : khjfpz[7].unit == 3 ? lists.hwzbs + '板' : lists.hwzjs + '件' }}
						</div>
					</el-form-item>
					<el-form-item label="搬运费" v-if="lists.byf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zbyf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[16].price }} * {{ khjfpz[16].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[16].unit == 2 ? lists.hwzmj + '平方' : khjfpz[16].unit == 3 ? lists.hwzbs + '板' :
								lists.hwzjs + '件' }}</div>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="贴标费" v-if="lists.tbf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.ztbf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[9].price }} * {{ khjfpz[9].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[9].unit
								== 2 ? lists.hwzmj + '平方' : khjfpz[9].unit == 3 ? lists.hwzbs + '板' : lists.hwzjs + '件' }}
						</div>
					</el-form-item>
					<el-form-item label="抄码费" v-if="lists.cmf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zcmf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[10].price }} * {{ khjfpz[10].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[10].unit == 2 ? lists.hwzmj + '平方' : khjfpz[10].unit == 3 ? lists.hwzbs + '板' :
								lists.hwzjs + '件' }}</div>
					</el-form-item>
					<el-form-item label="场地费" v-if="lists.cdf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zcdf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[12].price }} * {{ khjfpz[12].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[12].unit == 2 ? lists.hwzmj + '平方' : khjfpz[12].unit == 3 ? lists.hwzbs + '板' :
								lists.hwzjs + '件' }}</div>
					</el-form-item>
				</div>
				<div style="width: 25%;">
					<el-form-item label="打包费" v-if="lists.dbf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zdbf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[14].price }} * {{ khjfpz[14].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[14].unit == 2 ? lists.hwzmj + '平方' : khjfpz[14].unit == 3 ? lists.hwzbs + '板' :
								lists.hwzjs + '件' }}</div>
					</el-form-item>
					<el-form-item label="复冻费" v-if="lists.fdf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zfdf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[15].price }} * {{ khjfpz[15].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[15].unit == 2 ? lists.hwzmj + '平方' : khjfpz[15].unit == 3 ? lists.hwzbs + '板' :
								lists.hwzjs + '件' }}</div>
					</el-form-item>
					<el-form-item label="过磅费" v-if="lists.gbf_status == true">
						<div class="d-flex">
							<el-input-number v-model="lists.zgbf" :precision="2" size="mini"></el-input-number>
							<span style="color: #0091ff;margin-left: 8px;">元</span>
						</div>
						<div class='jfgs'>{{ khjfpz[17].price }} * {{ khjfpz[17].unit == 1 ? lists.hwzds + '吨' :
							khjfpz[17].unit == 2 ? lists.hwzmj + '平方' : khjfpz[17].unit == 3 ? lists.hwzbs + '板' :
								lists.hwzjs + '件' }}</div>
					</el-form-item>


				</div>
			</div>
			<div class="mb-4">
				<el-button type="primary" size="mini" @click="onSubmit">一键计费</el-button>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 180px;">
				<div class="m-4 d-flex">
					<div>货物信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="rcddhw" border style="width: 100%" key="tablec" size="mini"
						:header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column align="center" width="65" fixed="left">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button type="danger" size="mini" icon="el-icon-delete"
									@click="pustyldel(scope.$index)"></el-button>
							</template>
						</el-table-column>
						<el-table-column type="index" label="序号" width="45" align="center"
							fixed="left"></el-table-column>
						<el-table-column prop="hwmc" label="货物名称" width="80" fixed="left"></el-table-column>
						<el-table-column prop="bh" label="货物编码" width="100" align="center"
							fixed="left"></el-table-column>
						<el-table-column label="包装名称" align="center" width="140">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.bzjf"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="客称叫法" align="center" width="140">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.kc"></el-input>
							</template>
						</el-table-column>

						<el-table-column label="包装" align="center" width="110">
							<template slot-scope="scope">
								<el-select v-model="scope.row.hwbz" style="width: 100%;" size="mini">
									<el-option v-for="item in hwbzlist" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="" label="生产日期" align="center" width="170">
							<template slot-scope="scope">
								<el-date-picker v-model="scope.row.generation" align="right" type="date" size="mini"
									format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 90%;"
									:picker-options="pickerOptions">
								</el-date-picker>
								<!-- <el-input size="mini" v-model="scope.row.generation" style="width: 90%;" :min='0'></el-input> -->
							</template>
						</el-table-column>
						<el-table-column prop="jcrq" label="进仓日期" align="center" width="100"></el-table-column>
						<el-table-column label="运费单价" align="center" width="150">
							<template slot-scope="scope">
								<div class="d-flex">
									<el-input size="mini" v-model="scope.row.yfdj" style="width: 50%;"></el-input>
									<div style="margin-left: 3px;margin-right: 3px;">/</div>
									<el-select v-model="scope.row.yfdw" style="width: 50%;" size="mini">
										<el-option v-for="item in jfdwlist" :key="item.id" :label="item.name"
											:value="item.id"></el-option>
									</el-select>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="计费模式" align="center" width="120">
							<template slot-scope="scope">
								<el-select v-model="scope.row.jfms" style="width: 90%;" size="mini">
									<el-option v-for="item in jfmslist" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</template>
						</el-table-column>

						<el-table-column label="长度(米)" align="center" width="140">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.cd" style="width: 90%;" :min='0'
									:precision="2" @change="handjstj(scope.row, scope.$index, 0)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="宽度(米)" align="center" width="140">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.kd" style="width: 90%;" :min='0'
									:precision="2" @change="handjstj(scope.row, scope.$index, 0)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="高度(米)" align="center" width="140">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.gd" style="width: 90%;" :min='0'
									:precision="2" @change="handjstj(scope.row, scope.$index, 0)"></el-input-number>
							</template>
						</el-table-column>

						<!-- <el-table-column :label="lists.jfms == 0 ? '单位重量(kg)' : '单位高度(米)'" align="center" width="150"
							v-if="lists.jfdw == 2">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.dwzl" style="width: 90%;" :min='0'
									@change="handjstj(scope.row, scope.$index, 0)"
									v-if="lists.jfms == 0"></el-input-number>
								<el-input-number size="mini" v-model="scope.row.dwgd" style="width: 90%;" :min='0'
									@change="handjstj(scope.row, scope.$index, 0)" v-else></el-input-number>
							</template>
						</el-table-column> -->
						<!-- 修改 -->
						<el-table-column label="单位重量(kg)" align="center" width="150">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.dwzl" style="width: 90%;" :min='0'
									@change="handjstj(scope.row, scope.$index, 0)"></el-input-number>
							</template>
						</el-table-column>

						<el-table-column label="每件重量(kg)" align="center" width="150">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.mjzl" style="width: 90%;" :min='0'
									:precision="2" @change="handjstj(scope.row, scope.$index, 0)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="件数" align="center" width="130">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.js" style="width: 90%;" :min='0'
									@change="handjstj(scope.row, scope.$index, 0)"></el-input-number>
							</template>
						</el-table-column>

						<el-table-column v-if="lists.jfdw == 3" prop="bzdsl" align="center" label="板可放最大件数" width="120">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.bzdsl" style="width: 90%;" :min='0'
									@change="handjstj(scope.row, scope.$index, 1)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column v-if="lists.jfdw == 3" prop="bsl" align="center" label="板数量" width="80"></el-table-column>
						<el-table-column prop="" label="计费标准" align="center" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.jfpz_id" filterable style="width: 100%;" size="mini">
									<el-option v-for="item in jfbzlist" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="" label="备注" align="center" width="130">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.note" style="width: 90%;" :min='0'></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="jfsl" label="计费数量" align="center" width="80">
							<template slot-scope="scope">
								{{ scope.row.jfsl }}{{ lmfdw }}
								<!-- {{ scope.row.jfsl }}吨 -->
							</template>
						</el-table-column>
						<el-table-column prop="jfsl" label="操作数量" align="center" width="80">
							<template slot-scope="scope">
								{{ scope.row.cz_num }}{{ lmfdw }}
							</template>
						</el-table-column>
						<el-table-column prop="" label="单件面积" align="center" width="80">
							<template slot-scope="scope">
								{{ scope.row.djmj }}平方
							</template>
						</el-table-column>
						<el-table-column prop="" label="单件体积" align="center" width="80">
							<template slot-scope="scope">
								{{ scope.row.djtj }}立方
							</template>
						</el-table-column>
						<el-table-column prop="mj" label="总面积" align="center" width="80"></el-table-column>
						<el-table-column prop="tj" label="总体积" align="center" width="80"></el-table-column>
						<el-table-column prop="zzl" label="总重量" align="center" width="80"></el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		<el-dialog title="选择货物" :visible.sync="createModel" top="5vh" customClass="customWidth">
			<button-search class="" placeholder="货物名称" @search="searchEvent">
				<template #left>
					<el-button type="primary" size="mini" icon="el-icon-plus" @click="tjhw">添加货物</el-button>
				</template>
				<template #form>
					<el-form inline ref="form" :model="search" label-width="80px">
						<!-- 搜索内容 -->
						<el-form-item label="货物编号" class="mb-0">
							<el-input v-model="search.bh" size="mini" placeholder="货物编号"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
							<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
			<div v-if="tjhw_statu == 1">
				<div class="d-flex my-2">
					<div style="width: 34%;align-items: center;" class="d-flex">
						<div class="mr-2" style="width: 30%;">货物名称</div>
						<el-input v-model="tjhwList.name" style="width: 50%;" size="mini"></el-input>
					</div>
					<div style="width: 33%;align-items: center;" class="d-flex">
						<div class="mr-2" style="width: 30%;">编号</div>
						<el-input v-model="tjhwList.bh" style="width: 50%;" size="mini" :disabled="true"></el-input>
					</div>
					<div style="width: 33%;align-items: center;" class="d-flex">
						<div class="mr-2" style="width: 30%;">面积</div>
						<el-input-number v-model="tjhwList.mj" size="mini" style="width: 50%;"
							:precision="2"></el-input-number>
					</div>
				</div>
				<div class="d-flex">
					<div style="width: 34%;align-items: center;" class="d-flex">
						<div class="mr-2" style="width: 30%;">重量</div>
						<el-input-number v-model="tjhwList.zl" size="mini" style="width: 50%;"></el-input-number>
					</div>
					<div style="width: 33%;align-items: center;" class="d-flex">
						<div class="mr-2" style="width: 30%;">体积</div>
						<el-input-number v-model="tjhwList.tj" size="mini" style="width: 50%;"
							:precision="2"></el-input-number>
					</div>
					<div style="width: 33%;align-items: center;">
						<el-button type="primary" size="mini" @click="tjhwSub">提交</el-button>
					</div>
				</div>
			</div>
			<div style="width: 100%;" class="d-flex">
				<el-table ref="multipleTable" :data="ckcplist" tooltip-effect="dark" height="420" size="mini"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="bh" label="编号" width="90"></el-table-column>
					<el-table-column prop="name" label="货物名称" width="180"></el-table-column>
					<el-table-column prop="mj" label="面积" align="center"></el-table-column>
					<el-table-column prop="tj" label="体积" align="center"></el-table-column>
					<el-table-column prop="zl" label="重量" align="center"></el-table-column>
				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="1" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white"
			style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="width: 160px;margin-left: 30px;">经办人：<span style="color: #0091ff;">{{ lists.cjrname }}</span>
			</div>
			<div style="width: 120px;">共<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{ lists.hwxm
					}}</span>项</div>
			<div style="width: 190px;">
				计费数量：
				<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{ charging }}</span>
				<span style="color: #0091ff;">{{ lmfdw }}</span>
			</div>
			<div style="width: 190px;">
				操作数量：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">{{ totalWeight }}</span><span
					style="color: #0091ff;">吨</span>
			</div>
			<div style="width: 160px;">运费：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">
					{{ freight }}
					<!-- {{ lists.zyf }} -->
				</span>元</div>
			<div style="width: 160px;">总件数：<span style="color: #0091ff;margin-left: 10px;margin-right: 10px;">
					{{ totals }}
					<!-- {{ lists.zyf }} -->
				</span>件</div>
			<el-button type="primary" @click="submit" style="margin-left: 10%;">提交</el-button>
		</el-footer>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import buttonSearch from '@/components/common/button-search.vue';
import common from '@/common/mixins/common.js';
import Decimal from 'decimal.js';
export default {
	mixins: [common],
	inject: ['app', 'layout'],
	components: {
		buttonSearch
	},
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				shortcuts: [{
					text: '今天',
					onClick(picker) {
						picker.$emit('pick', new Date());
					}
				}]
			},
			jfsl: 0,
			zzl: 0,
			hj: 0,
			lists: {
			},
			ywylist: [],
			khlist: [],
			cklist: [],
			ckcplist: [],
			bmlist: [],
			valuea: false,
			createModel: false,
			preUrl: 'cpgl',
			multipleSelection: [],
			rcddhw: [],

			// 计费标准
			jfbz_num: {
				numA: 0,
				numB: 0,
				numC: 0,
				jfdw: '吨'
			},


			lmfdw: '',
			tableDatab: [],
			thlxlist: [],
			hwlxlist: [],
			ccfslist: [],
			jfdwlist: [],
			jfbzlist: [],
			hwbzlist: [],
			jfzqlist: [{
				id: 1,
				name: '1天'
			}, {
				id: 3,
				name: '3天'
			}, {
				id: 7,
				name: '7天'
			}, {
				id: 10,
				name: '10天'
			}],
			ddsxlist: [{
				id: 0,
				name: '散货'
			}, {
				id: 1,
				name: '大货'
			}],
			jfmslist: [{
				id: 0,
				name: '重量'
			}, {
				id: 1,
				name: '体积'
			}],
			flfylxlist: [],
			search: {
				keyword: "",
				bh: ''
			},
			bantj: 1.2,//每板体积
			dqkhxx: {},// 当前客户信息
			tjhw_statu: 0,// 添加货物状态
			tjhwList: {},// 货物列表
			khjfpz: []
		}
	},
	computed: {
		...mapState({
			user: state => state.user.user,
		}),

		//操作数量（吨）
		totalWeight() {
			console.log("this.hj========>", this.hj)
			// if (this.hj > 0) {
			// 	return Math.round(this.hj * 10) / 10
			// } else {
			// 	return this.hj
			// }
			let num = 0
			this.rcddhw.forEach((item) => {
				num += Number(item.cz_num)
				console.log("cz_num=========>", item.cz_num)
			})
			if (num < 0.5 && num > 0) {
				return 0.5
			} else {
				return num.toFixed(1)
			}
		},
		//运费
		freight() {
			let num = 0
			this.rcddhw.forEach((item) => {
				console.log("item---------->", item)
				num += Number(item.yfdj * item.jfsl)
				// if (this.yfdw == 1) { //吨
				// 	num += item.yfdj * item.cz_num
				// } else if (this.yfdw == 2) { //平方
				// 	num += item.yfdj * item.mj
				// } else if (this.yfdw == 3) { // 板
				// 	num += item.yfdj * item.js
				// } else if (this.yfdw == 4) { //件
				// 	num +=item.yfdj * item.bsl

				// } else if (this.yfdw == 6) {  //吨/平方
				// 	if(item.cz_num>item.mj){
				// 		num +=item.yfdj * item.cz_num
				// 	}else{
				// 		num +=item.yfdj * item.mj
				// 	}
				// }
			})
			return (Math.round(num * 10) / 10).toFixed(1)
		},
		//计费数量
		charging() {
			let num = 0
			this.rcddhw.forEach((item) => {
				console.log("item---------->", item)
				num += Number(item.jfsl)
			})
			if (num < 0.5 && num > 0) {
				return 0.5
			} else {
				return num.toFixed(1)
			}
		},
		//总件数
		totals(){
			// scope.row.js
			let num =0
			this.rcddhw.forEach((item) => {
				if(item.js){
					num+=item.js
				}
			})
			return num
		},

	},
	created() {
		this.lists = this.$route.params.data;
		if (this.lists.id != 0) {
			this.axios.get('/admin/khjfpz/' + this.lists.kh_id, {
				token: true
			}).then(res => {
				this.khjfpz = res.data.data
			})
		}
		this.hj = this.lists.hj
		this.jfsl = this.lists.jfsl
		if (this.lists.hwxm != 0) {
			this.rcddhw = this.lists.rcddhw
		}
		this.axios.get('/admin/khxxsrcdd', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
		this.axios.get('/admin/flflx/1', { token: true }).then(res => {
			this.flfylxlist = res.data.data.list;
		});
		this.axios.get('/admin/ccfsrcdd', { token: true }).then(res => {
			this.ccfslist = res.data.data;
		});
		this.axios.get('/admin/hwbz/1', { token: true }).then(res => {
			console.log(res.data.data.list, '包装')
			this.hwbzlist = res.data.data.list;
		});
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
		});
		this.axios.get('/admin/thlx/1', {
			token: true
		}).then(res => {
			this.thlxlist = res.data.data.list;
		});
		this.axios.get('/admin/hwlx/1', { token: true }).then(res => {
			console.log(res.data.data.list, '货物类型')
			this.hwlxlist = res.data.data.list;
		});
		this.axios.get('/admin/jfdwrcdd', { token: true }).then(res => {
			console.log("计费单位=======>", res.data.data)
			this.jfdwlist = res.data.data;
			if (this.lists.id) {
				let datas = this.jfdwlist.filter(item => {
					return item.id == this.lists.jfdw
				})
				this.lmfdw = datas[0].name
			}
		});

		this.axios.get('/admin/jfbz/1', { token: true }).then(res => {
			this.jfbzlist = res.data.data.list;
		});



	},
	methods: {
		// 一键计费
		onSubmit() {
			let num = 0
			for (let i of this.khjfpz) {
				if (num > 5) {
					let price = this.jfgs(i.price, i.unit)
					console.log(price, i.name)
					if (num == 6) {
						this.lists.zgcf = price
					} else if (num == 7) {
						this.lists.zjbf = price
					} else if (num == 8) {
						this.lists.zlmf = price
					} else if (num == 9) {
						this.lists.ztbf = price
					} else if (num == 10) {
						this.lists.zcmf = price
					} else if (num == 12) {
						this.lists.zcdf = price
					} else if (num == 13) {
						this.lists.zfbf = price
					} else if (num == 14) {
						this.lists.zdbf = price
					} else if (num == 15) {
						this.lists.zfdf = price
					} else if (num == 16) {
						this.lists.zbyf = price
					} else if (num == 17) {
						this.lists.zgbf = price
					}
				}
				num += 1
			}
		},
		// 公式
		jfgs(e, type) {
			if (type == 1) { // 吨
				return Math.floor(parseFloat(e) * this.lists.hwzds)
			} else if (type == 2) { // 平方
				return Math.floor(parseFloat(e) * this.lists.hwzmj)
			} else if (type == 3) { // 板
				return Math.floor(parseFloat(e) * this.lists.hwzbs)
			} else { // 件
				return Math.floor(parseFloat(e) * this.lists.hwzjs)
			}
		},
		curr(val) {
			let data = this.khlist.filter(item => {
				return item.id == val
			})
			this.dqkhxx = data[0]

			// 拿到客户计费配置
			this.axios.get('/admin/khjfpz/' + data[0].id, {
				token: true
			}).then(res => {
				this.khjfpz = res.data.data
			})

			this.jfbz_num.numA = this.dqkhxx.czf_dj
			this.jfbz_num.numB = this.dqkhxx.gcczf_dj
			this.jfbz_num.numC = this.dqkhxx.gwczf_dj
			this.jfbz_num.jfdw = this.dqkhxx.zdcz_jd_dw == 2 ? '平方' : '吨'
			this.lists.bh = data[0].j_name + '-' + data[0].cfpc
			this.lists.pch = data[0].cfpc
			this.lists.jfdw = data[0].jfdw_id
			this.lists.jfzq = data[0].jfzq
			this.lists.flfylx = data[0].flflx_id
			this.lists.thlx = data[0].hyfs
			let datas = this.jfdwlist.filter(item => {
				return item.id == data[0].jfdw_id
			})
			this.lmfdw = datas[0].name
		},
		// 添加货物
		tjhw() {
			this.tjhw_statu = 1
		},
		// 提交货物
		tjhwSub() {
			this.axios.post('/admin/cpgl', this.tjhwList, {
				token: true
			}).then(res => {
				this.getList()
				this.$message({
					type: "success",
					message: "添加成功"
				})
				this.tjhw_statu = 0

			})
		},
		pustyl() {
			if (!this.lists.kh_id) {
				this.$message({
					type: "warning",
					message: "请先选择客户"
				})
			} else {
				this.createModel = true;
			}
		},
		pustyldel(e) {
			this.rcddhw.splice(e, 1)
			let list = this.rcddhw
			let cc = '00'
			// 是否有编号 没有

			this.rcddhw = []
			for (let i of list) {
				if (this.rcddhw.length + 1 > 9) {
					cc = '0'
				}
				i.bh = this.lists.bh + '-' + cc + (this.rcddhw.length + 1)

				this.rcddhw.push(i)
			}
		},
		submits(e) {
			// 生成编号
			let cc = '00'
			for (let i of e) {
				if (this.rcddhw.length + 1 > 9) {
					cc = '0'
				}
				let data = {
					bh: this.lists.bh + '-' + cc + (this.rcddhw.length + 1),
					kh_id: this.lists.kh_id,
					hwmc: i.name,
					kc: '',
					bzjf: '',
					hwbz: '',
					jcrq: this.lists.ddrq,
					yfdj: 80,
					yfdw: this.lists.jfdw,
					cd: 0,
					kd: 0,
					gd: 0,
					dwzl: i.zl,
					dwgd: 0,
					mjzl: 0,
					js: 0,
					mj: 0,
					djmj: 0,
					djtj: 0,
					bzdsl: 0,
					bsl: 0,
					tj: 0,
					jfsl: 0,
					zzl: 0,
					jfpz_id: '',
					cz_num: 0,
					cz_price: 0
				}
				this.rcddhw.push(data)
				console.log(i, this.rcddhw.length)
			}
			this.lists.hwxm = this.rcddhw.length
			this.createModel = false;
		},
		getListUrl() {

			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&keyword=${this.search.keyword}&bh=${this.search.bh}`
		},
		getListResult(e) {
			this.ckcplist = e.list;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},

		handleChange(lx, e, index) {
			if (lx == 'sl') {
				this.rcddhw[index].hj = this.rcddhw[index].dj * this.rcddhw[index].sl
			} else if (lx == 'dj') {
				this.rcddhw[index].hj = this.rcddhw[index].dj * this.rcddhw[index].sl
			} else {
				this.rcddhw[index].dj = this.rcddhw[index].hj / this.rcddhw[index].sl
			}
			this.lists.spze = 0
			for (let i of this.rcddhw) {
				this.lists.spze += i.hj
			}
			this.lists.ddje = this.lists.spze * (this.lists.sl / 100) + this.lists.spze
		},
		handleChanges(e) {
			this.lists.ddje = this.lists.spze * (e / 100) + this.lists.spze
		},
		// 计算体积
		handjstj(e, index, status) {
			let cd = e.cd // 长度
			let kd = e.kd // 宽度
			let gd = e.gd // 高度
			let js = e.js // 件数
			let zl = e.mjzl // 重量
			zl = zl / 1000

			let mjmj = (cd * kd).toFixed(2) // 每件面积
			let mjtj = (cd * kd * gd).toFixed(2) // 每件体积
			let zmj = (cd * kd * js).toFixed(2) // 总面积
			let ztj = (cd * kd * gd * js).toFixed(2) // 总体积
			let cz_num = this.twoDecimal(zl * js)//(zl * js).toFixed(2) // 操作重量
			let bzdsl = 0
			if (status == 1) { // 自定义板数量
				bzdsl = e.bzdsl // 板最大数量
			} else { // 默认
				console.log("mjtj==========>", mjtj)
				bzdsl = this.bantj / parseFloat(mjtj)//Math.floor(this.bantj / parseFloat(mjtj)) // 板最大数量
				console.log("bzdsl====>", bzdsl)
			}

			this.rcddhw[index].djmj = mjmj
			this.rcddhw[index].djtj = mjtj
			this.rcddhw[index].mj = zmj
			this.rcddhw[index].tj = ztj
			this.rcddhw[index].bzdsl = bzdsl
			console.log("Math.ceil(js / bzdsl).toFixed(2)=======>", js , bzdsl)
			this.rcddhw[index].bsl = Math.ceil(js / bzdsl).toFixed(2)
			this.rcddhw[index].cz_num = cz_num
			// 操作费计算
			console.log(this.khjfpz)
			if (e.jfpz_id == 1) {
				this.rcddhw[index].cz_price = Math.floor(parseFloat(this.khjfpz[0].price) * cz_num)
			} else if (e.jfpz_id == 2) {
				this.rcddhw[index].cz_price = Math.floor(parseFloat(this.khjfpz[1].price) * cz_num)
			} else if (e.jfpz_id == 3) {
				this.rcddhw[index].cz_price = Math.floor(parseFloat(this.khjfpz[2].price) * cz_num)
			}
			console.log(this.rcddhw[index].cz_price)
			// console.log(this.khjfpz[0].price, this.khjfpz[1].price, this.khjfpz[2].price)




			// 计费数量统计
			// if (this.lists.jfdw == 1) { // 吨
			// 	this.rcddhw[index].jfsl = this.twoDecimal03(zl * js) //(zl * js).toFixed(2) // 计费数量
			// 	this.rcddhw[index].zzl = this.twoDecimal(zl * js)// (zl * js).toFixed(2) // 总重量
			// 	let jfsl = 0
			// 	let zzl = 0
			// 	let hj = 0
			// 	for (let i of this.rcddhw) {
			// 		jfsl += parseFloat(i.jfsl)
			// 		zzl += parseFloat(i.zzl)
			// 	}
      //
			// 	this.jfsl = jfsl.toFixed(2)
			// 	this.zzl = zzl.toFixed(2)
			// 	hj = jfsl
      //
			// 	if (jfsl < 0.5) {
			// 		hj = 0.5
			// 	}
			// 	if (hj > 0 && hj < 0.01) {
			// 		hj = 0.01
			// 	}
			// 	this.hj = hj.toFixed(2)
			// } else if (this.lists.jfdw == 2) { // 平方
			// 	if (this.rcddhw[index].jfms == 0) { // 重量
			// 		this.rcddhw[index].jfsl = this.twoDecimal03(js * zl / (this.rcddhw[index].dwzl / 1000)) //(js * zl / (this.rcddhw[index].dwzl / 1000)).toFixed(2)
			// 		this.rcddhw[index].zzl = this.twoDecimal(zl * js) // (zl * js).toFixed(2) // 总重量
			// 		let jfsl = 0
			// 		let zzl = 0
			// 		let hj = 0
			// 		for (let i of this.rcddhw) {
			// 			jfsl += parseFloat(i.jfsl)
			// 			zzl += parseFloat(i.zzl)
			// 		}
      //
			// 		this.jfsl = jfsl.toFixed(2)
			// 		this.zzl = zzl.toFixed(2)
			// 		hj = jfsl
			// 		if (hj > 0 && hj < 0.01) {
			// 			hj = 0.01
			// 		}
			// 		this.hj = hj.toFixed(2)
			// 	} else { // 体积
			// 		this.rcddhw[index].jfsl = this.twoDecimal03((cd * kd * gd) / dwgd * js)//((cd * kd * gd) / dwgd * js).toFixed(2)
			// 		this.rcddhw[index].zzl = this.twoDecimal(zl * js) //(zl * js).toFixed(2) // 总重量
			// 		let jfsl = 0
			// 		let zzl = 0
			// 		let hj = 0
			// 		for (let i of this.rcddhw) {
			// 			jfsl += parseFloat(i.jfsl)
			// 			zzl += parseFloat(i.zzl)
			// 		}
      //
			// 		this.jfsl = jfsl.toFixed(2)
			// 		this.zzl = zzl.toFixed(2)
			// 		hj = jfsl
			// 		if (hj > 0 && hj < 0.01) {
			// 			hj = 0.01
			// 		}
			// 		this.hj = hj.toFixed(2)
			// 	}
			// } else if (this.lists.jfdw == 3) { // 板
			// 	console.log("this.twoDecimal03(this.rcddhw[index].bsl)=======>", this.twoDecimal03(this.rcddhw[index].bsl))
			// 	this.rcddhw[index].jfsl = this.twoDecimal03(this.rcddhw[index].bsl) //this.rcddhw[index].bsl
			// 	this.rcddhw[index].zzl = this.twoDecimal(zl * js) // (zl * js).toFixed(2) // 总重量
			// 	let jfsl = 0
			// 	let zzl = 0
			// 	let hj = 0
			// 	for (let i of this.rcddhw) {
			// 		jfsl += parseFloat(i.jfsl)
			// 		zzl += parseFloat(i.zzl)
			// 	}
      //
			// 	this.jfsl = jfsl.toFixed(2)
			// 	this.zzl = zzl.toFixed(2)
			// 	hj = jfsl
			// 	this.hj = hj.toFixed(2)
			// } else if (this.lists.jfdw == 4) { // 件
			// 	this.rcddhw[index].jfsl = this.twoDecimal03(js) // js
			// 	this.rcddhw[index].zzl = this.twoDecimal(zl * js) //(zl * js).toFixed(2) // 总重量
			// 	let jfsl = 0
			// 	let zzl = 0
			// 	let hj = 0
			// 	for (let i of this.rcddhw) {
			// 		jfsl += parseFloat(i.jfsl)
			// 		zzl += parseFloat(i.zzl)
			// 	}
      //
			// 	this.jfsl = jfsl.toFixed(2)
			// 	this.zzl = zzl.toFixed(2)
			// 	hj = jfsl
			// 	if (hj > 0 && hj < 0.01) {
			// 		hj = 0.01
			// 	}
			// 	this.hj = hj.toFixed(2)
			// }

      if(this.rcddhw[index].jfms == 0){

      }else if(this.rcddhw[index].jfms == 1){
        this.rcddhw[index].jfsl = new Decimal(cd).mul(kd).mul(gd).mul(js).div(2)
        console.log('jfsl', cd, kd, gd, js, this.rcddhw[index].jfsl)
        this.lmfdw = this.jfmslist[this.rcddhw[index].jfms].name

        this.rcddhw[index].cz_num = new Decimal(e.mjzl).mul(js).div(this.rcddhw[index].dwzl)

      }

			this.yfjs()
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search.keyword = e
				this.getList()
				return
			}
			// 高级搜索
			this.getList()
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				keyword: "",
				bh: '',
			}
		},
		yfjs() {
			this.lists.rcddhw = this.rcddhw
			let hwzjs = 0
			let hwzds = 0
			let hwzmj = 0
			let hwzbs = 0
			let hwztj = 0
			for (let i of this.rcddhw) {
				hwzjs += i.js
				hwzds += parseFloat(i.zzl)
				hwzmj += parseFloat(i.mj)
				hwzbs += parseFloat(i.bsl)
				hwztj += parseFloat(i.tj)
			}
			this.lists.hwzjs = hwzjs
			this.lists.hwzds = hwzds
			this.lists.hwzmj = hwzmj
			this.lists.hwzbs = hwzbs
			this.lists.hwztj = hwztj.toFixed(2)
			// 运费
			let yufei = 0
			if (this.lists.thlx == 1) {
				this.lists.zyf = 0
			} else if (this.lists.thlx == 2) { // 班车
				if (this.dqkhxx.hyfs_bcdw == 1) { // 单位：件
					yufei = parseFloat(this.dqkhxx.hyfs_dj) * hwzjs
					if (yufei < 3) {
						// 保底3元
						yufei = 3
					} else if (yufei >= 80 && yufei < 160) {
						// 满80元打9折
						yufei = Math.round(yufei * (9 / 10))
					} else if (yufei >= 160 && yufei < 240) {
						// 满160元打8折
						yufei = Math.round(yufei * (8 / 10))
					} else {
						// 满240元打7.5折
						yufei = Math.round(yufei * (7.5 / 10))
					}
				} else { // 单位：吨
					yufei = 80 * hwzds
					if (yufei < 3) {
						// 保底3元
						yufei = 3
					} else if (yufei >= 80 && yufei < 160) {
						// 满80元打9折
						yufei = Math.round(yufei * (9 / 10))
					} else if (yufei >= 160 && yufei < 240) {
						// 满160元打8折
						yufei = Math.round(yufei * (8 / 10))
					} else {
						// 满240元打7.5折
						yufei = Math.round(yufei * (7.5 / 10))
					}
				}
				this.lists.zyf = yufei
			} else if (this.lists.thlx == 1) { // 自提 默认运费为0
				this.lists.zyf = yufei
			} else if (this.lists.thlx == 3) { // 黄沙
				let newhwds = hwzds * 1000
				if (newhwds <= 200) { // 200公斤内 30元
					yufei = 30
				} else if (newhwds > 201 && newhwds <= 300) { // 201公斤-300公斤 40元
					yufei = 40
				} else if (newhwds > 301 && newhwds <= 400) { // 301公斤-400公斤 50元
					yufei = 50
				} else if (newhwds > 401 && newhwds <= 500) { // 401公斤-500公斤 60元
					yufei = 60
				} else if (newhwds > 501 && newhwds <= 1000) { // 501公斤-1000公斤 70元
					yufei = 70
				} else if (newhwds > 1001 && newhwds <= 1200) { // 1001公斤-1200公斤 80元
					yufei = 80
				} else if (newhwds > 1201 && newhwds <= 1400) { // 1201公斤-1400公斤 100元
					yufei = 100
				} else if (newhwds > 1401 && newhwds <= 1600) { // 1401公斤-1600公斤 110元
					yufei = 110
				} else if (newhwds > 1601 && newhwds <= 1800) { // 1601公斤-1800公斤 130元
					yufei = 130
				} else if (newhwds > 1801 && newhwds <= 2000) { // 1801公斤-2000公斤 140元
					yufei = 140
				} else if (newhwds > 2001 && newhwds <= 4000) { // 2001公斤-4000公斤 160元
					yufei = 160
				}
				this.lists.zyf = yufei
			} else if (this.lists.thlx == 4) { // 省冷
				if (this.lists.thlx_sl_zc == 1) { // 专车 (待补充)
					yufei = 200
					this.lists.zyf = yufei
				} else { // 非专车
					let newtj = ((hwzds * 1000) / hwztj) * 2 // 平均每2立方的重量kg
					if (newtj < 700) { // 2立方体积重量为700Kg（不含）以下的，60元/吨
						yufei = Math.round(hwzds * 60)
					} else {
						yufei = Math.round(hwzds * 40)
					}
					if (yufei < 50) {
						yufei = 50
					}
				}
				// 运费时间-优惠
				var now = new Date();
				var hour = now.getHours();
				if (hour >= 12 && hour < 18) {
					this.lists.zyf = Math.round(yufei * (8.5 / 10))
				} else {
					this.lists.zyf = Math.round(yufei * (9 / 10))
				}
				// this.lists.zyf = yufei
			}

		},
		//提交
		submit() {
			this.lists.hj = this.hj
			this.lists.jfsl = this.jfsl
			if (this.zzl != 0) {
				this.lists.zzl = this.zzl
			}

			let x = this.lists
			console.log(x)
			if (x.ccfs == '') {
				this.$message({
					type: "warning",
					message: "请选择储存方式"
				})
			} else if (x.rcddhw.length == 0) {
				this.$message({
					type: "warning",
					message: "请选择储存货物"
				})
			} else if (x.hwlx == '') {
				this.$message({
					type: "warning",
					message: "请选择货物类型"
				})
			} else {
				this.layout.showLoading()
				let url = this.lists.id === 0 ? '/admin/rcdd' : '/admin/rcdd/' + this.lists.id

				this.axios.post(url, x, {
					token: true
				}).then(res => {
					console.log(res);
					this.$message({
						type: "success",
						message: this.lists.id === 0 ? "下单成功" : "修改成功"
					})
					this.$router.push({
						name: "rcgl_ddcl_rcdd"
					})
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			}


		},

		twoDecimal(num) {
			const numx = Number(num)
			// console.log(numx, (Math.round(numx * 10) / 10).toFixed(2))
			return (Math.round(numx * 10) / 10).toFixed(2)
		},

		//小数点后两位
		twoDecimal03(num) {
			console.log("num===========>", num)
			const numx = Number(num)
			if (numx < 0.3 && numx > 0) {
				return 0.3
			} else {
				console.log(numx.toFixed(2))
				return numx.toFixed(2)
			}
		},
	},
}
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 4px !important;
}

.pt-a {
	padding-top: 20px;
}

.el-form-item__label {
	width: 84px !important;
}

.jfgs {
	line-height: 0;
	font-size: 10px;
	color: #9a9a9a;
}
</style>
